import React, { useState, useEffect } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import Modal from 'components/Modal/Modal';
import { Button } from 'components/ui';
import localeUtils from 'utils/LanguageLocale';
import typography from 'style/typography';
import getModal from 'services/api/cms/getModal';
import { globalModals } from 'utils/globalModals';
import ComponentList from 'components/Content/ComponentList';
import ContentConstants from 'constants/content';
import QuestionsAndAnswersEN from 'components/ProductPage/QuestionsAndAnswers/locales/QuestionsAndAnswers_en_US';
import QuestionsAndAnswersFR from 'components/ProductPage/QuestionsAndAnswers/locales/QuestionsAndAnswers_fr_CA';

const { CONTEXTS } = ContentConstants;
const { COMMUNITY_QUESTIONS_AND_ANSWERS } = globalModals;
const { getLocalisedDataFromResource, isFrench } = localeUtils;

const ModalGuidelines = ({ globalModals: globalModalsData, onDismiss }) => {
    const [contentfulData, setContentfulData] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const { sid } = globalModalsData[COMMUNITY_QUESTIONS_AND_ANSWERS] || {};

        if (sid) {
            const { country, channel, language } = Sephora.renderQueryParams;
            getModal({ country, language, channel, sid })
                .then(data => {
                    setContentfulData(data?.data);
                    setIsLoading(false);
                })
                .catch(() => {
                    setIsLoading(false);
                });
        } else {
            setIsLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getText = getLocalisedDataFromResource(QuestionsAndAnswersEN, QuestionsAndAnswersFR);
    const termsOfUseUrl = isFrench() ? 'https://www.sephora.com/ca/fr/beauty/terms-of-use' : 'https://www.sephora.com/beauty/terms-of-use';

    if (isLoading) {
        return null;
    }

    return (
        <Modal
            isOpen={true}
            onDismiss={onDismiss}
            width={2}
        >
            <Modal.Header>
                <Modal.Title>{contentfulData?.title ? contentfulData.title : getText('questionAnswerGuidelines')}</Modal.Title>
            </Modal.Header>
            <Modal.Body css={typography}>
                {contentfulData?.items?.length ? (
                    <ComponentList
                        items={contentfulData.items}
                        context={CONTEXTS.MODAL}
                        removeFirstItemMargin={true}
                        removeLastItemMargin={true}
                    />
                ) : (
                    <>
                        <p>{getText('modalGuidelinesModeration')}</p>
                        <p>{getText('considerBeforeAsking')}</p>
                        <ul>
                            <li>{getText('focusOnProduct')}</li>
                            <li>
                                {getText('relevantDetails')} <a href={termsOfUseUrl}>{getText('termsOfUse')}</a>.
                            </li>
                            <li>{getText('noMedicalAdvice')}</li>
                            <li>
                                {getText('language1')} <a href={termsOfUseUrl}>{getText('termsOfUse')}</a>
                                {getText('language2')}
                            </li>
                        </ul>
                        <p>{getText('answersGuidelines')}</p>
                        <ul>
                            <li>{getText('answersFocusOnExperience')}</li>
                            <li>{getText('answersDetails')}</li>
                            <li>
                                {getText('answersModerators')} <a href={termsOfUseUrl}>{getText('termsOfUse')}</a>.
                            </li>
                            <li>{getText('answersNoMedicalAdvice')}</li>
                            <li>
                                {getText('answersLanguage1')} <a href={termsOfUseUrl}>{getText('termsOfUse')}</a>
                                {getText('answersLanguage2')}
                            </li>
                        </ul>
                        <p>
                            {getText('rightsReservations')} <a href={getText('contactUsUrl')}>{getText('contactUsUrl')}</a>.
                        </p>
                        <p>{getText('nowAskAndAnswer')}</p>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    variant='primary'
                    hasMinWidth={true}
                    children={getText('done')}
                    onClick={onDismiss}
                />
            </Modal.Footer>
        </Modal>
    );
};

export default wrapFunctionalComponent(ModalGuidelines, 'ModalGuidelines');
